import { ApiUrls } from '../ApiConstants/ApiUrls'
import { FetchApi } from '../ApiFetch/ApiFetch';
import { HTTPMethod } from '../ApiFetch/HTTPMethod.types';
import { ServiceType } from '../ApiFetch/ServiceType.types';
import { CreateTextResponse } from '../ApiFetch/ApiResponse';
import { Guid } from 'guid-typescript';
import { ScheduledRetrievalFormData, UpdateScheduledRetrievalFormData } from '../../core/Types/ScheduledRetrieval.types';

export const getScheduledRetrievalGridData = async () => {
    const url = ApiUrls.SCHEDULED_RETRIEVALS;
    const response = await FetchApi({
        endpoint: url,
        method: HTTPMethod.Get,
        apiVersion: 1,
        apiType: ServiceType.Import
    });
    return CreateTextResponse(response);
}

export const getScheduledRetrievalDetails = async (id: Guid) => {
    const url = ApiUrls.GET_SCHEDULED_RETRIEVAL_DETAILS.replace('{id}', id.toString());
    const response = await FetchApi({
        endpoint: url,
        method: HTTPMethod.Get,
        apiVersion: 1,
        apiType: ServiceType.Import
    });
    return CreateTextResponse(response);
}

export const updateScheduledRetrieval = async (id: Guid, data: UpdateScheduledRetrievalFormData) => {
    const url = ApiUrls.UPDATE_SCHEDULED_RETRIEVAL_DETAILS.replace('{id}', id.toString());
    const response = await FetchApi({
        endpoint: url,
        method: HTTPMethod.Put,
        headers: {
            'Content-Type': 'application/json'
        },
        apiVersion: 1,
        apiType: ServiceType.Import,
        body: JSON.stringify(data)
    });
    return CreateTextResponse(response);
}

export const createScheduledRetrieval = async (data: ScheduledRetrievalFormData) => {
    const url = ApiUrls.SCHEDULED_RETRIEVALS;
    const response = await FetchApi({
        endpoint: url,
        method: HTTPMethod.Post,
        headers: {
            'Content-Type': 'application/json'
        },
        apiVersion: 1,
        apiType: ServiceType.Import,
        body: JSON.stringify(data)
    });
    return CreateTextResponse(response);
}
